<template>
    <div class="row pt-4">
        <!-- Left Block -->
        <div class="col-sm-12">
        </div>
        <div class="col-sm-12 col-md-10 mx-auto">
          <button type="button"
            class="btn mb-4"
            @click="$router.go(-1)"
          >
            <i class="fa fa-arrow-left"></i>
            &nbsp; Volver
          </button>
          <card header-text="Editar inspirador">
            <div class="card-body card-block">
                <Registrar :edition="true" />
            </div>
          </card>
        </div>
    </div>
</template>

<script>
import Registrar from './Registrar'

export default {
  components: { Registrar }
}

</script>
